<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.show_subscription") }}</h4>
      <v-chip
        :color="getStatusColor(data.status)"
        text-color="white"
        class="ml-3"
      >
        {{ data._status || data.status }}
      </v-chip>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-between mb-4">
        <div class="wrapper">
          <v-chip color="amber darken-2" text-color="white" class="mr-2">
            {{ $t("PLACEHOLDERS.subscription_date") }}: {{ data.created_at }}
          </v-chip>
          <v-chip color="blue darken-2" text-color="white" class="mr-2">
            {{ $t("PLACEHOLDERS.ads_number") }}: {{ data.ads_number || 0 }}
          </v-chip>
          <v-chip color="green darken-2" text-color="white" class="mr-2">
            {{ $t("PLACEHOLDERS.used_ads") }}: {{ data.used_ads || 0 }}
          </v-chip>
          <v-chip color="purple darken-2" text-color="white" class="mr-2">
            {{ $t("PLACEHOLDERS.remaining_ads") }}:
            {{ data.remaining_ads || 0 }}
          </v-chip>
          <v-chip color="orange darken-2" text-color="white" class="mr-2">
            {{ $t("PLACEHOLDERS.paid_amount") }}:
            {{ data.price ? `${data.price} ${$t("CURRENCY.sr")}` : "0" }}
          </v-chip>
        </div>

        <v-chip :color="getStatusColor(data.status)" text-color="white">
          {{ data._status || data.status }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Subscription Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Subscriber Info -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscriber_name')"
            :value="data.subscriber?.user?.name"
            disabled
            class="disabled_input"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscriber_mobile')"
            :value="data.subscriber?.user?.mobile"
            disabled
            class="disabled_input"
          />

          <base-input
            col="4"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            :value="data.subscriber?.user?.email"
            disabled
            class="disabled_input"
          />
          <!-- End:: Subscriber Info -->

          <!-- Start:: Package Info -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.package_name')"
            :value="data.package?.name"
            disabled
            class="disabled_input"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            :value="
              data.package?.price
                ? `${data.package.price} ${$t('CURRENCY.sr')}`
                : '-'
            "
            disabled
            class="disabled_input"
          />
          <!-- End:: Package Info -->

          <!-- Start:: Subscription Details -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscription_start_date')"
            :value="data.created_at"
            disabled
            class="disabled_input"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.paid_amount')"
            :value="data.price ? `${data.price} ${$t('CURRENCY.sr')}` : '-'"
            disabled
            class="disabled_input"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscription_status')"
            :value="data._status || data.status"
            disabled
            class="disabled_input"
          />
          <!-- End:: Subscription Details -->

          <!-- Start:: Ads Usage -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ads_number')"
            :value="data.ads_number"
            disabled
            class="disabled_input"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.used_ads')"
            :value="data.used_ads"
            disabled
            class="disabled_input"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.remaining_ads')"
            :value="data.remaining_ads"
            disabled
            class="disabled_input"
          />
          <!-- End:: Ads Usage -->
        </div>
      </form>
      <!-- ==== End:: Subscription Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>
<script>
export default {
  name: "ShowSubscription",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection
      data: {
        id: null,
        price: null,
        ads_number: null,
        used_ads: null,
        remaining_ads: null,
        status: null,
        _status: null,
        created_at: null,
        package: {
          id: null,
          name: null,
          price: null,
          ads_number: null,
        },
        subscriber: {
          user: {
            id: null,
            name: null,
            mobile: null,
            email: null,
          },
        },
      },
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Get Status Color
    getStatusColor(status) {
      switch (status) {
        case "active":
          return "green";
        case "expired":
          return "red";
        case "cancelled":
          return "orange";
        default:
          return "grey";
      }
    },
    // End:: Get Status Color

    // Start:: Get Subscription Data
    async getSubscriptionData() {
      this.isWaitingRequest = true;

      try {
        let res = await this.$axios({
          method: "GET",
          url: `subscriptions/${this.$route.params.id}`,
        });

        this.data = res.data.data.subscription;
        this.isWaitingRequest = false;
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message ||
            this.$t("MESSAGES.someThingWentWrong")
        );
      }
    },
    // End:: Get Subscription Data
  },

  created() {
    // Start:: Fire Methods
    this.getSubscriptionData();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.crud_form_wrapper {
  padding: 20px;
}

.form_title_wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form_title_wrapper h4 {
  color: #404b3e;
  margin-bottom: 0;
}

.single_step_form_content_wrapper {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.badges_wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.badges_wrapper .wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.disabled_input {
  opacity: 0.8;
}

.disabled_input .v-input {
  background-color: #f5f5f5;
}

/* Responsive design for badges */
@media (max-width: 768px) {
  .badges_wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .badges_wrapper .wrapper {
    margin-bottom: 10px;
  }
}
</style>
